// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.selected-stay[data-v-24d84004] {\n    background-color: rgba(255,255,255,0.075);\n}\n.stay-inactive[data-v-24d84004] {\n    opacity: 0.4;\n}\n", ""]);
// Exports
module.exports = exports;
